import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { TROOP_NAMES } from "Utils/Common";
import { StringValue } from "./StringValue";
import { StringArray } from "./StringArray";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Custom SCHS Run">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        {task.taskstatusdetail.mapstodo.map((item, index) => {
          return (
            <div>
              <div className="infokey" style={{ fontSize: "small" }}>
                {"Step " + (index + 1)}
              </div>
              <div className="infovalue" style={{ fontSize: "small" }}>
                <div>
                  {item.level.levelname}
                  <br />
                  {item.heroToUse}
                  <br />
                  {Object.keys(item.troops).map((key) => {
                    return (
                      <>
                        {TROOP_NAMES[key]}:{item.troops[key]}
                        <br />
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
        <StatusSection task={task} />
        <StringValue
          label={"Currently Running Map:"}
          value={task.taskstatusdetail.currentmap}
        />
        <StringValue
          label={"Total Scored:"}
          value={task.taskstatusdetail.totalScoreBillions}
        />
        <StringArray
          label={"Report:"}
          array={task.taskstatusdetail.report}
          valueParser={(item) =>
            `${item.levelname}:(Score:${item.score})(bestScore:${
              item.bestscore
            })`
          }
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
